import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
  Stack,
} from "@mui/material";

type ConfirmationDialogProps = {
  open: boolean;
  title: string;
  description?: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  isPending?: boolean;
};

const ConfirmationDialog = ({
  open,
  title,
  description,
  onConfirm,
  onCancel,
  confirmText = "Confirm",
  cancelText = "Cancel",
  isPending = false,
}: ConfirmationDialogProps) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" justifyContent="flex-end" gap={1} m={2} mt={0}>
          <Button variant="outlined" onClick={onCancel}>
            {cancelText}
          </Button>
          <Button
            disabled={isPending}
            variant="contained"
            onClick={onConfirm}
            endIcon={
              isPending ? <CircularProgress size={15} color="primary" /> : null
            }
          >
            {confirmText}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
